import { Sparkles, Heart, Leaf, Star, Droplets, Sun, Moon, Zap } from 'lucide-react';

export const treatmentCategories = {
  MASSAGES: 'Body Massages',
  RITUALS: 'Body Rituals',
  FACIALS: 'Facials',
  PACKAGES: 'Face & Body Packages',
  BIOHACKING: 'Biohacking & Therapeutic'
};

export const treatmentCategoriesES = {
  MASSAGES: 'Masajes Corporales',
  RITUALS: 'Rituales Corporales',
  FACIALS: 'Tratamientos Faciales',
  PACKAGES: 'Paquetes Faciales y Corporales',
  BIOHACKING: 'Biohacking y Terapéutico'
};

export const treatments = [
  // Body Massages
  {
    id: 'cbd-massage',
    name: 'MUSCLE-SOOTHING CBD MASSAGE',
    nameES: 'MASAJE RELAJANTE MUSCULAR CON CBD',
    category: treatmentCategories.MASSAGES,
    duration: 50,
    price: 120,
    description: 'Deep massage with organic CBD oil and natural essential oils. Reduces inflammation, relieves muscle tension, and provides an intense sense of calm.',
    descriptionES: 'Masaje profundo con aceite orgánico de CBD y aceites esenciales naturales. Reduce la inflamación, alivia la tensión muscular y proporciona una intensa sensación de calma.',
    benefits: [
      'Pain Relief',
      'Anti-Inflammatory', 
      'Deep Relaxation',
      'Muscle Recovery'
    ]
  },
  {
    id: 'head-neck-massage',
    name: 'ANTI-STRESS HEAD & NECK MASSAGE',
    nameES: 'MASAJE ANTI-ESTRÉS DE CABEZA Y CUELLO',
    category: treatmentCategories.MASSAGES,
    duration: 30,
    price: 75,
    description: 'Relaxing massage with organic essential oils, focused on the neck, scalp, and trapezius muscles. Releases accumulated tension and clears the mind.',
    descriptionES: 'Masaje relajante con aceites esenciales orgánicos, enfocado en el cuello, cuero cabelludo y músculos trapecio. Libera la tensión acumulada y despeja la mente.',
    benefits: [
      'Stress Relief',
      'Mental Clarity',
      'Tension Release',
      'Headache Relief'
    ]
  },
  {
    id: 'foot-reflexology',
    name: 'HOLISTIC FOOT REFLEXOLOGY',
    category: treatmentCategories.MASSAGES,
    duration: 50,
    price: 120,
    description: 'Therapeutic foot massage with organic oil that stimulates reflex points to harmonize the entire body. Ideal for restoring balance, energy, and lightness.',
    benefits: [
      'Full Body Balance',
      'Energy Restoration', 
      'Circulation',
      'Harmony'
    ]
  },
  {
    id: 'couples-massage',
    name: 'COUPLES MASSAGE',
    category: treatmentCategories.MASSAGES,
    duration: 50,
    price: 200,
    description: 'A sensory experience to share. Enveloping massage with organic aromatic oils that relax, connect, and awaken the senses. Perfect for reconnecting.',
    benefits: [
      'Shared Experience',
      'Connection',
      'Romance',
      'Relaxation'
    ]
  },
  {
    id: 'holistic-relaxation',
    name: 'HOLISTIC RELAXATION MASSAGE',
    category: treatmentCategories.MASSAGES,
    duration: 50,
    price: 100,
    description: 'Full-body massage with organic essential oils that soothe body and mind. Light to medium pressure. Ideal for releasing stress, tension, and reconnecting with yourself.',
    benefits: [
      'Stress Relief',
      'Full Body',
      'Essential Oils',
      'Mind-Body Connection'
    ]
  },
  {
    id: 'deep-tissue',
    name: 'INTENSIVE DEEP TISSUE MASSAGE',
    category: treatmentCategories.MASSAGES,
    duration: 50,
    price: 115,
    description: 'Full-body massage with a focus on tension areas. Relieves muscle knots and stiffness in the neck, back, and shoulders. Firm and therapeutic pressure.',
    benefits: [
      'Deep Tension Relief',
      'Muscle Recovery',
      'Therapeutic',
      'Firm Pressure'
    ]
  },
  {
    id: 'swedish-massage',
    name: 'THERAPEUTIC SWEDISH MASSAGE',
    category: treatmentCategories.MASSAGES,
    duration: 50,
    price: 115,
    description: 'Classic technique with firm pressure and long strokes. Stimulates circulation, relaxes muscles, and revitalizes body and mind.',
    benefits: [
      'Classic Technique',
      'Circulation',
      'Muscle Relaxation',
      'Revitalizing'
    ]
  },
  {
    id: 'smart-massage',
    name: 'Smart Massage',
    category: treatmentCategories.MASSAGES,
    duration: 20,
    price: 20,
    description: 'Smart chair with aromatherapy and blue sky ambiance. A quick break that releases tension, recharges your energy, and boosts your mood.',
    benefits: [
      'Quick Relief',
      'Technology',
      'Aromatherapy',
      'Energy Boost'
    ]
  },

  // Body Rituals
  {
    id: 'detox-ritual',
    name: 'BODY DETOX RITUAL WITH CHOCOLATE OR SEAWEED',
    category: treatmentCategories.RITUALS,
    duration: 80,
    price: 155,
    description: 'Exfoliation followed by a personalized wrap: chocolate to nourish and revitalize, or seaweed to detoxify and drain. Finish with a draining massage that activates circulation, reduces fluid retention, and lightens the body.',
    benefits: [
      'Detoxification',
      'Nourishing',
      'Drainage',
      'Circulation'
    ]
  },
  {
    id: 'exfoliating-ritual',
    name: 'RENEWING EXFOLIATING RITUAL + MASSAGE',
    category: treatmentCategories.RITUALS,
    duration: 60,
    price: 135,
    description: 'Body treatment that combines exfoliation with natural salts tailored to the skin type and a relaxing massage with organic oils. It restores softness, radiance, and deep well-being.',
    benefits: [
      'Skin Renewal',
      'Exfoliation',
      'Radiance',
      'Softness'
    ]
  },
  {
    id: 'hydration-ritual',
    name: 'DEEP HYDRATION RITUAL & MASSAGE',
    category: treatmentCategories.RITUALS,
    duration: 60,
    price: 140,
    description: 'Gentle exfoliation, relaxing body massage with natural oils, and application of ultra-hydrating cream. Ideal for dry skin or after sun exposure. Silky skin, nourished and a calm body.',
    benefits: [
      'Deep Hydration',
      'Dry Skin Care',
      'Nourishing',
      'Silky Skin'
    ]
  },
  {
    id: 'body-exfoliation',
    name: 'EXFOLIACIÓN CORPORAL',
    category: treatmentCategories.RITUALS,
    duration: 30,
    price: 85,
    description: 'Renew your skin with natural exfoliants made from salts and oils, or personalized treatments tailored to your skin type. Removes dead skin cells, deeply hydrates, and leaves your skin soft, radiant, and ready for an even, long-lasting tan.',
    benefits: [
      'Skin Renewal',
      'Natural Exfoliants',
      'Radiant Skin',
      'Tan Preparation'
    ]
  },
  {
    id: 'hair-ritual',
    name: 'BOTANICAL HAIR RITUAL',
    category: treatmentCategories.RITUALS,
    duration: 50,
    price: 115,
    description: 'Natural oils and tinctures applied with a deep massage that stimulates growth, activates circulation, and strengthens the roots. Intense relaxation and a balanced scalp. The hair is not washed afterward to preserve the benefits of the natural ingredients.',
    benefits: [
      'Hair Growth',
      'Scalp Health',
      'Natural Oils',
      'Circulation'
    ]
  },
  {
    id: 'mother-child',
    name: 'MOTHER & DAUGHTER / SON RITUAL',
    category: treatmentCategories.RITUALS,
    duration: 50,
    price: 125,
    description: 'Gentle massage in turns with a single therapist. A relaxing experience to share connection and quality time in an intimate setting.',
    benefits: [
      'Family Bonding',
      'Shared Experience',
      'Quality Time',
      'Gentle Touch'
    ]
  },

  // Facials
  {
    id: 'facial-him',
    name: 'REVITALIZING FACIAL FOR HIM',
    category: treatmentCategories.FACIALS,
    duration: 50,
    price: 110,
    description: 'Facial designed for men\'s skin. Deep cleansing, intense hydration, and facial and scalp massage with soothing cream. Ideal after shaving or to restore comfort, freshness, and tone to the face.',
    benefits: [
      'Men\'s Skincare',
      'Deep Cleansing',
      'Hydration',
      'Post-Shave Care'
    ]
  },
  {
    id: 'express-facial',
    name: 'EXPRESS REVITALIZING FACIAL',
    category: treatmentCategories.FACIALS,
    duration: 30,
    price: 75,
    description: 'An instant-effect facial break. Cleansing, gentle exfoliation, and facial massage with a highly absorbent serum or moisturizing cream. Fresher, more radiant, and revitalized skin in just 30 minutes.',
    benefits: [
      'Quick Results',
      'Instant Glow',
      'Revitalizing',
      'Express Treatment'
    ]
  },
  {
    id: 'eye-treatment',
    name: 'MIRADA RADIANTE EXPRÉS',
    category: treatmentCategories.FACIALS,
    duration: 30,
    price: 75,
    description: 'Targeted treatment to revitalize the eye area. Gentle cleansing of the eye contour, manual drainage, application of decongestant serum, and massage with cooling tools. Reduces signs of fatigue, puffiness, and dark circles, leaving the eye contour firmer, fresher, and well-rested.',
    benefits: [
      'Eye Care',
      'Anti-Puffiness',
      'Dark Circles',
      'Firming'
    ]
  },
  {
    id: 'botanical-balance',
    name: 'DEEP CLEANSING & BOTANICAL BALANCE',
    category: treatmentCategories.FACIALS,
    duration: 50,
    price: 99,
    description: 'Purifies, balances, and revitalizes. Personalized gentle exfoliation, warm compresses, natural mask, and facial massage. A complete ritual that deeply cleanses without irritation, leaving the skin fresh and radiant.',
    benefits: [
      'Deep Cleansing',
      'Balance',
      'Natural Mask',
      'Gentle Care'
    ]
  },
  {
    id: 'hydration-glow',
    name: 'INTENSE HYDRATION & NATURAL GLOW',
    category: treatmentCategories.FACIALS,
    duration: 50,
    price: 115,
    description: 'Advanced treatment with hyaluronic acid and plant-based collagen. Gentle cleansing, deep nourishment, and a boost of visible radiance. Ideal for dehydrated, dry, or dull skin. Restores elasticity, softness, and natural glow from the very first session.',
    benefits: [
      'Hyaluronic Acid',
      'Collagen Boost',
      'Hydration',
      'Natural Glow'
    ]
  },
  {
    id: 'facial-lift',
    name: 'NATURAL FACIAL LIFT',
    category: treatmentCategories.FACIALS,
    duration: 50,
    price: 125,
    description: 'Our star anti-aging treatment. Natural firming actives, deep massage with Gua Sha and jade rollers to redefine the face and stimulate collagen. Immediate lifting effect and visibly firmer, toned skin.',
    benefits: [
      'Anti-Aging',
      'Gua Sha',
      'Jade Rollers',
      'Lifting Effect'
    ]
  },

  // Face & Body Packages
  {
    id: 'lifting-nutrition',
    name: 'LIFTING & NUTRITION RENEWAL (BODY & FACE)',
    category: treatmentCategories.PACKAGES,
    duration: 50,
    price: 125,
    description: 'Gentle exfoliation, nourishing body massage with ultra-nourishing cream, and a 60-minute lifting facial with firming actives that provide an immediate visible lifting effect. Nourish the skin, redefine the facial contour, and enjoy a total renewal of body and face.',
    benefits: [
      'Total Renewal',
      'Lifting Effect',
      'Nourishing',
      'Body & Face'
    ]
  },
  {
    id: 'zen-escape',
    name: 'ZEN ESCAPE (BODY & FACE)',
    category: treatmentCategories.PACKAGES,
    duration: 80,
    price: 145,
    description: 'Enjoy a 50-minute relaxing massage combined with a 30-minute Botanical Balance mini facial. Release tension, fully disconnect, and restore fresh, radiant skin. A perfect escape to renew body and mind.',
    benefits: [
      'Complete Relaxation',
      'Mind & Body',
      'Radiant Skin',
      'Zen Experience'
    ]
  },
  {
    id: 'purity-renewal',
    name: 'PURITY & RENEWAL RITUAL (BODY & FACE)',
    category: treatmentCategories.PACKAGES,
    duration: 80,
    price: 165,
    description: 'Body exfoliation, nourishing wrap (chocolate or seaweed), and a 50-minute draining massage, combined with a gentle facial cleansing and 30-minute draining massage. Eliminates toxins, reduces fluid retention, and revitalizes your face and body, leaving a feeling of lightness and renewed energy.',
    benefits: [
      'Detoxification',
      'Toxin Elimination',
      'Energy Renewal',
      'Lightness'
    ]
  },

  // Biohacking & Therapeutic
  {
    id: 'total-biohacking',
    name: 'TOTAL BIOHACKING EXPERIENCE',
    category: treatmentCategories.BIOHACKING,
    duration: 90,
    price: 111,
    description: 'Advanced combination of red light infrared sauna, Ballancer Pro pressotherapy, and personalized 5D massage. Comprehensive treatment that detoxifies, activates metabolism, reduces fluid retention, and releases deep tension. Ideal for feeling lighter, renewed, and energized.',
    benefits: [
      'Advanced Technology',
      'Metabolism Boost',
      'Detoxification',
      'Energy Renewal'
    ]
  },
  {
    id: 'smart-detox',
    name: 'SMART DETOX WITH INFRARED SAUNA',
    category: treatmentCategories.BIOHACKING,
    duration: 70,
    price: 80,
    description: 'Body exfoliation in a wet area and infrared sauna therapy with red light. A deep wellness experience that eliminates toxins, activates metabolism, and strengthens the immune system. Purifies, oxygenates, and improves sleep quality and skin health.',
    benefits: [
      'Infrared Therapy',
      'Immune Boost',
      'Sleep Quality',
      'Skin Health'
    ]
  },
  {
    id: 'anticellulite',
    name: 'ANTICELLULITE WITH BALLANCER PRESSOTHERAPY',
    category: treatmentCategories.BIOHACKING,
    duration: 70,
    price: 70,
    description: 'Body exfoliation in a wet area and treatment with Ballancer Pro pressotherapy. Activates circulation, improves skin texture, and effectively fights cellulite. A draining, firming, and revitalizing treatment for firmer, toned skin.',
    benefits: [
      'Cellulite Reduction',
      'Circulation',
      'Skin Firming',
      'Toning'
    ]
  },

  // Special Offer Treatments (with exact names as shown in offers)
  {
    id: 'bioenergetic-wellness',
    name: 'Experience the Power of Bioenergetic Wellness',
    category: treatmentCategories.BIOHACKING,
    duration: 90,
    price: 99,
    description: '3 Bioenergetic Readings in One Week + One Personalized Bio Cor Binaural Sound Treatment for Just 25€!',
    benefits: [
      'Gain deep insights into your energy levels',
      'Identify imbalances and stress points',
      'Enhance mental and emotional health',
      'Personalized wellness data',
      'Profound relaxation and stress relief'
    ]
  },
  {
    id: 'escapada-perfecta',
    name: 'Tu Escapada Perfecta',
    category: treatmentCategories.MASSAGES,
    duration: 50,
    price: 89,
    description: 'Halloween Massage with Clove, Cinnamon & Sweet Orange Oils + Exclusive Spa Access!',
    benefits: [
      'Themed aromatherapy massage',
      'Full spa facility access',
      'Halloween ambiance',
      'Perfect couples experience',
      'Exclusive seasonal blend'
    ]
  },
  {
    id: 'summer-facial-glow',
    name: 'Summer Luxury Facial Glow',
    category: treatmentCategories.FACIALS,
    duration: 50,
    price: 99,
    description: 'Complete luxury facial treatment designed to leave your skin radiant and refreshed for summer!',
    benefits: [
      'Deep exfoliation and pore cleaning',
      'Red light therapy',
      'Hydration mask',
      'Cold therapy lymphatic massage',
      'Complimentary spa access'
    ]
  },
  {
    id: 'anti-cellulite-summer',
    name: 'Anti-Cellulite Summer Treatment',
    category: treatmentCategories.BIOHACKING,
    duration: 60,
    price: 75,
    description: 'Complete anti-cellulite treatment combining massage and Body BALLANCER technology!',
    benefits: [
      '25 min anti-cellulite massage',
      '35 min Body BALLANCER treatment',
      'Improved circulation and skin texture',
      'Relaxing and rejuvenating',
      'Summer-ready body confidence'
    ]
  },
  {
    id: 'complete-spa-day',
    name: 'Complete Spa Day Experience',
    category: treatmentCategories.PACKAGES,
    duration: 240,
    price: 199,
    description: 'Indulge in a day of pure relaxation with infrared sauna, intelligent massage, and aromatherapy!',
    benefits: [
      'Detoxifying infrared sauna',
      'Intelligent chair massage',
      'Soothing aromatherapy',
      'Full spa facility access',
      'Free membership bonus'
    ]
  },

  // Biohacking Service Treatments (with exact names as shown in services)
  {
    id: 'infrared-sauna',
    name: 'Full Spectrum Infrared Sauna',
    category: treatmentCategories.BIOHACKING,
    duration: 30,
    price: 40,
    description: 'Deep penetrating heat therapy for detoxification, pain relief, and cellular regeneration',
    benefits: [
      'Deep detoxification',
      'Pain relief',
      'Cellular regeneration',
      'Improved circulation'
    ]
  },
  {
    id: 'bioenergetic-measurement',
    name: 'Bioenergetic Measurement',
    category: treatmentCategories.BIOHACKING,
    duration: 45,
    price: 60,
    description: 'Advanced analysis of your body\'s energy fields and biorhythms for personalized wellness protocols',
    benefits: [
      'Energy field analysis',
      'Biorhythm assessment',
      'Personalized protocols',
      'Wellness insights'
    ]
  },
  {
    id: 'ballancer-pro',
    name: 'Body Ballancer Pressotherapy',
    category: treatmentCategories.BIOHACKING,
    duration: 35,
    price: 50,
    description: 'Pneumatic compression therapy for enhanced circulation, lymphatic drainage, and recovery',
    benefits: [
      'Enhanced circulation',
      'Lymphatic drainage',
      'Faster recovery',
      'Body contouring'
    ]
  },
  {
    id: 'sound-therapy',
    name: 'Vibrational Sound Therapy',
    category: treatmentCategories.BIOHACKING,
    duration: 60,
    price: 80,
    description: 'Therapeutic frequencies and vibrations to harmonize body, mind, and cellular healing',
    benefits: [
      'Therapeutic frequencies',
      'Body-mind harmonization',
      'Cellular healing',
      'Deep relaxation'
    ]
  }
];

export const getTreatmentsByCategory = (category) => {
  return treatments.filter(treatment => treatment.category === category);
};

export const getTreatmentById = (id) => {
  return treatments.find(treatment => treatment.id === id);
};

export const getAllCategories = () => {
  return Object.values(treatmentCategories);
}; 
